module.exports = fox._r("fonts/simplifica.woff", __webpack_public_path__ + "fonts/1Vq6EH3.woff");


//////////////////
// WEBPACK FOOTER
// ./fonts/simplifica.woff
// module id = 45
// module chunks = 4